import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b0b4015c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b0b4015c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0b4015c')) {
      api.createRecord('b0b4015c', component.options)
    } else {
      api.reload('b0b4015c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b0b4015c", function () {
      api.rerender('b0b4015c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/billingCalendarTrendChartArchive/index.vue"
export default component.exports